import { gql } from '@nerdwallet/apollo';

export const QUERY = gql`
  query getMarketplaceEntityForReferralBanner($id: ID!) {
    marketplaceEntityV2(id: $id) {
      id
      name
      productType
      versionId
      ... on MarketplaceEntityWithPlacementInterface {
        cta {
          link
          subtext
          type
        }
        analyticsProps {
          institutionId
          offerId
          productId
        }
        monetizable
      }
    }
  }
`;
